/**
 * Created by Rodrigo Quesada on 09/04/17.
 */
import {Routes} from '@angular/router';
import {DashboardPageComponent} from './dashboard-page.component';

export const rootRoutePath = 'dashboard';

const routes: Routes = [{
    path: rootRoutePath,
    component: DashboardPageComponent,
    data: {withSectionNav: false, impersonationAllowed: true}
}];
export default routes;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/dashboard/dashboard-page.routing.ts